module.exports = __webpack_public_path__ + "static/media/ruhtinas-vertical-blue-bg-dark-gold-300x300.23bd8086.png";